// extracted by css-extract-rspack-plugin
export default {"MetabotLogo":"A7UMY"};